import { IconButton } from "@material-ui/core";
import { MoreVertRounded } from "@material-ui/icons";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { MdNoAccounts } from "react-icons/md";
import { AiOutlineWarning } from "react-icons/ai";
import { PiShieldWarningBold } from "react-icons/pi";
import BanUser from "../../models/AdminPanel/BanUser";
import { FaIdCard } from "react-icons/fa";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { COLORS } from "../../../assets/colors";
import { RiRoadMapLine } from "react-icons/ri";
import CreateRideModal from "./CreateRideModal";
// import { Divider } from "@material-ui/core";

const tableHeaders = [
  "Avatar",
  "First Name",
  "Last Name",
  "Email",
  "Phone",
  "DOB",
  "Joined",
  "Gender",
  "CNIC",
  "CNIC Status",
  "License",
  "License Status",
  "Actions",
];

const CustomerTable = ({ customers }) => {
  const { currentUser } = useSelector((state) => state.auth);
  const [isOpen, setIsOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const [showBanModal, setShowBanModal] = useState(false);
  const [showRideModal, setShowRideModal] = useState(false);
  const ddref = useRef();

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      setIsOpen(false);
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleOutsideClick = (event) => {
    if (ddref.current && !ddref.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const toggleDropdown = (item) => {
    if (activeItem?.id === item.id) {
      setIsOpen(!isOpen);
    } else {
      setActiveItem(item);
      setIsOpen(true);
    }
  };

  const onBanUser = () => {
    setIsOpen(false);
    setShowBanModal(true);
  };

  const onWarnUser = () => {
    setIsOpen(false);
    toast.info(`Warning sent to ${activeItem.first_name}`);
  };

  const onVerifyLicenseOfUser = async (data) => {
    try {
      const res = await api.post(`admin/user/verify-license/${data.id}`);
      if (res.status === 200) {
        toast.success("License marked as verified");
      }
    } catch (err) {
      toast.error("Failed to verify license");
    }
    setIsOpen(false);
  };

  const onRejectLicenseOfUser = async (data) => {
    try {
      const res = await api.post(`admin/user/reject-license/${data.id}`);
      if (res.status === 200) {
        toast.info("License marked as rejected");
      }
    } catch (err) {
      toast.error("Failed to reject license");
    }
    setIsOpen(false);
  };

  const onVerifyCnicOfUser = async (data) => {
    try {
      const res = await api.post(`admin/user/verify-cnic/${data.id}`);
      if (res.status === 200) {
        toast.success("CNIC marked as verified");
      }
    } catch (err) {
      toast.error("Failed to verify CNIC");
    }
    setIsOpen(false);
  };

  const onMakeAdmin = async (data) => {
    try {
      const res = await api.post(`admin/user/promote/${data.id}`);
      if (res.status === 200) {
        toast.success("User promoted to admin successfully");
      }
    } catch (err) {
      toast.error("Failed to promote user to admin");
    }
    setIsOpen(false);
  };

  const onCreateRide = (data) => {
    setActiveItem(data);
    setIsOpen(false);
    setShowRideModal(true);
  };

  return (
    <TableContainer>
      <StyledTable>
        <thead>
          <tr>
            {tableHeaders.map((header, index) => (
              <th key={index}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {customers?.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              <TableCell>
                <div className="avatar-wrapper">
                  <img
                    src={
                      row.avatar_url ||
                      `https://ui-avatars.com/api/?name=${row.first_name}&background=random`
                    }
                    alt="avatar"
                  />
                </div>
              </TableCell>
              <TableCell className="bold">{row.first_name}</TableCell>
              <TableCell className="bold">{row.last_name}</TableCell>
              <TableCell>{row.email}</TableCell>
              <TableCell>{row.mobile_number}</TableCell>
              <TableCell>{moment(row.dob).format("DD MMM, YYYY")}</TableCell>
              <TableCell>{moment(row.created_at).format("DD MMM, YYYY")}</TableCell>
              <TableCell>{row.gender}</TableCell>
              <TableCell>
                <div className="doc-images">
                  {row.cnic_front && (
                    <a href={row.cnic_front} target="_blank" rel="noreferrer">
                      <img src={row.cnic_front} alt="cnic front" />
                    </a>
                  )}
                  {row.cnic_back && (
                    <a href={row.cnic_back} target="_blank" rel="noreferrer">
                      <img src={row.cnic_back} alt="cnic back" />
                    </a>
                  )}
                </div>
              </TableCell>
              <TableCell>
                <StatusBadge verified={row.cnic_verified}>
                  {row.cnic_verified ? "Verified" : "Unverified"}
                </StatusBadge>
              </TableCell>
              <TableCell>
                <div className="doc-images">
                  {row.license_front && (
                    <a href={row.license_front} target="_blank" rel="noreferrer">
                      <img src={row.license_front} alt="license front" />
                    </a>
                  )}
                  {row.license_back && (
                    <a href={row.license_back} target="_blank" rel="noreferrer">
                      <img src={row.license_back} alt="license back" />
                    </a>
                  )}
                </div>
              </TableCell>
              <TableCell>
                <StatusBadge 
                  verified={row.license_status === "verified"}
                  rejected={row.license_status === "rejected"}
                >
                  {row.license_status}
                </StatusBadge>
              </TableCell>
              <TableCell>
                <ActionWrapper>
                  <IconButton onClick={() => toggleDropdown(row)}>
                    <MoreVertRounded />
                  </IconButton>
                  {activeItem?.id === row.id && isOpen && (
                    <DropdownMenu ref={ddref}>
                      <MenuItem onClick={() => onBanUser(row)} className="danger">
                        <MdNoAccounts /> Ban User
                      </MenuItem>
                      <MenuItem onClick={() => onWarnUser(row)} className="warning">
                        <AiOutlineWarning /> Warn User
                      </MenuItem>
                      <MenuItem onClick={() => onCreateRide(row)}>
                        <RiRoadMapLine /> Create Ride
                      </MenuItem>
                      <Divider />
                      <MenuItem onClick={() => onVerifyCnicOfUser(row)}>
                        <FaIdCard /> Verify CNIC
                      </MenuItem>
                      <MenuItem onClick={() => onVerifyLicenseOfUser(row)}>
                        <FaIdCard /> Verify License
                      </MenuItem>
                      <MenuItem onClick={() => onRejectLicenseOfUser(row)} className="danger-text">
                        <FaIdCard /> Reject License
                      </MenuItem>
                      {currentUser?.email === "support@gosawari.com" && (
                        <>
                          <Divider />
                          <MenuItem onClick={() => onMakeAdmin(row)}>
                            <PiShieldWarningBold /> Make Admin
                          </MenuItem>
                        </>
                      )}
                    </DropdownMenu>
                  )}
                </ActionWrapper>
              </TableCell>
            </TableRow>
          ))}
        </tbody>
      </StyledTable>
      {showBanModal && (
        <BanUser
          title={`Ban ${activeItem?.first_name}`}
          cancelBtnText={"Cancel"}
          handleClose={() => setShowBanModal(false)}
          confirmBtnText={"Submit"}
          open={showBanModal}
          data={activeItem}
        />
      )}
      {showRideModal && (
        <CreateRideModal
          open={showRideModal}
          handleClose={() => setShowRideModal(false)}
          user={activeItem}
        />
      )}
    </TableContainer>
  );
};

export default CustomerTable;

const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  position: relative;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;

  th {
    padding: 1rem;
    background: #F8FAFC;
    color: ${COLORS.adminTextSecondary};
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    position: sticky;
    top: 0;
    z-index: 10;
  }
`;

const TableRow = styled.tr`
  border-bottom: 1px solid rgba(0, 0, 0, 0.03);
  transition: background 0.2s ease;

  &:hover {
    background: rgba(56, 189, 248, 0.03);
  }

  &:last-child {
    border-bottom: none;
  }
`;

const TableCell = styled.td`
  padding: 1rem;
  color: ${COLORS.adminTextPrimary};
  font-size: 0.875rem;
  vertical-align: middle;

  &.bold {
    font-weight: 600;
  }

  .avatar-wrapper {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid #fff;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .doc-images {
    display: flex;
    gap: 0.5rem;
    img {
      width: 40px;
      height: 40px;
      border-radius: 4px;
      object-fit: cover;
      border: 1px solid #ddd;
      transition: transform 0.2s;
      &:hover {
        transform: scale(1.1);
      }
    }
  }
`;

const StatusBadge = styled.span`
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  display: inline-flex;
  
  background: ${props => props.verified ? "rgba(16, 185, 129, 0.1)" : props.rejected ? "rgba(239, 68, 68, 0.1)" : "rgba(100, 116, 139, 0.1)"};
  color: ${props => props.verified ? COLORS.adminSuccess : props.rejected ? COLORS.adminError : COLORS.adminTextSecondary};
  text-transform: capitalize;
`;

const ActionWrapper = styled.div`
  position: relative;
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
  z-index: 100;
  min-width: 180px;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
`;

const MenuItem = styled.button`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.625rem 0.75rem;
  width: 100%;
  border: none;
  background: none;
  font-size: 0.875rem;
  color: ${COLORS.adminTextPrimary};
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.2s;

  svg {
    font-size: 1.1rem;
    opacity: 0.7;
  }

  &:hover {
    background: #F1F5F9;
  }

  &.danger {
    color: ${COLORS.adminError};
    &:hover {
      background: rgba(239, 68, 68, 0.05);
    }
  }

  &.warning {
    color: ${COLORS.adminWarning};
    &:hover {
      background: rgba(245, 158, 11, 0.05);
    }
  }

  &.danger-text {
    color: ${COLORS.adminError};
  }
`;

const Divider = styled.div`
  height: 1px;
  background: rgba(0, 0, 0, 0.05);
  margin: 0.5rem 0;
`;

